import { render, staticRenderFns } from "./CompanySetup.vue?vue&type=template&id=3a07f1ff&"
import script from "./CompanySetup.vue?vue&type=script&lang=js&"
export * from "./CompanySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports